import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Proposal } from '@trnsact/trnsact-shared-types';
import { ProposalsTable } from '../../tables';

interface Props {
  proposals?: Proposal[];
  routePath: string;
}

export const ProposalsCard = ({ proposals, routePath }: Props) => {
  return (
    <CardContainer title="Proposals">
      <ProposalsTable tableData={proposals} routePath={routePath} />
    </CardContainer>
  );
};
